
const iframe = () => import("@/views/iframe/index.vue");//iframe查看器


// 系统设置
const saferole = () => import("@/views/sysset/safe-role.vue");//角色管理
const safepermission = () => import("@/views/sysset/safe-permission.vue");//角色权限
const safeemployeerole = () => import("@/views/sysset/safe-employee-role.vue");//员工角色
const safedictionary = () => import("@/views/sysset/safe-dictionary.vue");//字典管理
const approvalProcess = () => import("@/views/sysset/approval-Process.vue");//审批流程设置

// 企业基础信息
const archives = () => import("@/views/enterInfo/archives.vue");//企业档案
const causingDisaster = () => import("@/views/enterInfo/causing-disaster.vue");//企业技术资料




// 内部机构
const safeemployee = () => import("@/views/organizedStructure/safe-employee.vue");//员工信息
const safeemployeeinfo = () => import("@/views/organizedStructure/components/employee/employeeInfo.vue");//新增/修改员工信息(员工信息的子路由)
const safeemployeeinfoCustom = () => import("@/views/organizedStructure/components/employee/employeeInfo-Custom.vue");//个人信息中进入的
const safeemployeeonduty = () => import("@/views/organizedStructure/safe-employee-onduty.vue");//值班信息
const safeemployeeclock = () => import("@/views/organizedStructure/safe-employee-clock.vue");//人员打卡
const safePostInfo = () => import("@/views/organizedStructure/safe-post-info.vue");//岗位职责
const safeEmployeeChange = () => import("@/views/organizedStructure/safe-employee-change.vue");//交接班
const safeEmployeeAppoint = () => import("@/views/organizedStructure/safe-employee-appoint.vue");//任命文件

//TODO:履职清单管理
const safefulfillConfig = () => import("@/views/fulfill/fulfill-config.vue");//履职明细

//TODO:风险管理
const saferisktype = () => import("@/views/risk_identification/safe-type-of-risk.vue");//风险信息
const saferisklevel = () => import("@/views/risk_identification/safe-level-of-risk.vue");//风险等级
// const saferiskentry = () => import("@/views/risk_identification/safe-entry-of-risk.vue");//风险识别
const saferiskidetion = () => import("@/views/risk_identification/safe-idetion-of-risk.vue");//风险清单
const safeSummaryapprove = () => import("@/views/risk_identification/safe-Summary-approve.vue");//风险转隐患审核
const saferiskarea = () => import("@/views/risk_identification/safe-Area-of-risk.vue");//风险区域分级
const saferiskSummary = () => import("@/views/risk_identification/safe-Summary-risk.vue");//风险初审
const safeControlRecordsRisk = () => import("@/views/risk_identification/safe-Control-Records-risk.vue");//管控记录
const safeRiskQuadChart = () => import("@/views/risk_identification/safe-risk-quad-chart.vue");//风险四色图
const safeStatisticalIndicatorsRisk = () => import("@/views/risk_identification/safe-statistical-indicators-risk.vue");//风险指标统计




//TODO:进出场设置
const safeVenueSetting = () => import("@/views/Venue_setting/safe-venue-setting.vue");//场地设置
const safeVenueRecords = () => import("@/views/Venue_setting/safe-venue-records.vue");//进出场记录

//TODO:合作方管理
const cooperationParty = () => import("@/views/cooperationParty/cooperation-list.vue");//合作方列表

//TODO:安全预警
const safeVideoConfig = () => import("@/views/Warning/video-config.vue");//摄像头配置
const safeVideoList = () => import("@/views/Warning/video-list.vue");//监控列表

const safeAlglist = () => import("@/views/Warning/alg-list.vue");//ai算法列表
const safeVideoAnalysis = () => import("@/views/Warning/video-analysis.vue");//AI视频分析
const safeAlarmlist = () => import("@/views/Warning/Alarm-list.vue");//AI报警列表

//TODO:告警记录
const safeBusWarning = () => import("@/views/busWarning/index.vue");//告警记录


//TODO:监控设备管理
const MonitorRecords = () => import("@/views/Monitor/Monitor-Records.vue");//设备台账


//TODO:法律法规
const safethelawItems = () => import("@/views/laws_and_regulations/safe-the-law-Items.vue");//法律规范
const safeCorporateSystem = () => import("@/views/laws_and_regulations/safe-Corporate-System.vue");//制度流程
const safeRulesRegulations = () => import("@/views/laws_and_regulations/safe-rules-regulations.vue");//规章制度

//TODO：安全检查
const securityConfig = () => import("@/views/security_check/config/security-Config.vue");//检查表配置
const checkScheduling = () => import("@/views/security_check/config/check-Scheduling.vue");//检查排班
const securityMission = () => import("@/views/security_check/Mission/security-Mission.vue");//安全检查台账
const safeCheckStatistical = () => import("@/views/security_check/Statistics/safe-check-statistical.vue");//安全检查统计
const checkCardRecords = () => import("@/views/security_check/config/check-Card-Records.vue");//区域签到台账
const checkSummary = () => import("@/views/security_check/config/check-Summary.vue");//安全检查汇总

//TODO：安全作业计划管理
const checkUnitSettings = () => import("@/views/Construction_programme/check-unit-Settings.vue");//作业单位设置
const checkConstructionplay = () => import("@/views/Construction_programme/check-Construction-play.vue");//危险作业计划
const checkConstructionOperationsplay = () => import("@/views/Construction_programme/check-Construction-Operations-play.vue");//特种作业计划

const checkConfirmTicket = () => import("@/views/Construction_programme/check-confirm-ticket.vue");//安全确认票配置
const checkConfirmTicketRecords = () => import("@/views/Construction_programme/check-confirm-ticket-Records.vue");//风险告知书
const checkConfirmHistory = () => import("@/views/Construction_programme/check-confirm-History.vue");//确认票发送历史

//TODO：设备管理
const device = () => import("@/views/device/device-list.vue");//设备台账


//TODO:隐患管理
const dangersMission = () => import("@/views/security_check/Mission/dangers-Mission.vue");//隐患检查任务
const safeDangersStatistical = () => import("@/views/security_check/Statistics/safe-Dangers-statistical.vue");//隐患检查统计
const safeSecurityAlert = () => import("@/views/security_check/Mission/safe-Security-Alert.vue");//安全预警


//TODO:隐患报告台账
const reportReward = () => import("@/views/dangerReport/report-reward.vue");//报告奖励设置
const reportList = () => import("@/views/dangerReport/report-list.vue");//隐患报告台账
const reportApprove = () => import("@/views/dangerReport/report-approve.vue");//报告审核记录

//TODO:三违管理
const Illegal = () => import("@/views/Illegal/Illegal-list.vue");//三违管理

//TODO:应急管理
const safeEmergencyPlan = () => import("@/views/emergency_management/safe-Emergency-plan.vue");//应急演练计划
const safeEmergencySupplies = () => import("@/views/emergency_management/safe-Emergency-Supplies.vue");//应急物资台账
const safeEmergencyTem = () => import("@/views/emergency_management/safe-Emergency-tem.vue");//应急小组
const safeEmergencyProcess = () => import("@/views/emergency_management/safe-Emergency-Process.vue");//应急流程
const safeEmergencyExercise = () => import("@/views/emergency_management/safe-Emergency-Exercise.vue");//单人数字演练
const safeEmergencyExercisePeople = () => import("@/views/emergency_management/safe-Emergency-Exercise-people.vue");//多人数字演练

const safeContingencyPlans = () => import("@/views/emergency_management/safe-Contingency-Plans.vue");//应急方案
const safeEmergencyResources = () => import("@/views/emergency_management/safe-Emergency-Resources.vue");//应急资源
const safeEmergencyTopicSetting = () => import("@/views/emergency_management/safe-Emergency-topic-setting.vue");//应急预案题目设置
const safeEmergencyExerciseResources = () => import("@/views/emergency_management/safe-Emergency-Exercise-Resources.vue");//应急演练记录
const safeEmergencyStatistics = () => import("@/views/emergency_management/safe-Emergency-Statistics.vue");//年度演练统计

const safeEmergencyExerciseMeet = () => import("@/views/emergency_management/safe-Emergency-Exercise-meet.vue");//应急预案
const safeEmergencyExerciseDrill = () => import("@/views/emergency_management/safe-Emergency-Exercise-drill.vue");//应急预案

//TODO：劳保物资管理
const laborlist = () => import("@/views/Labor_insurance/labor_list.vue");//劳保物资列表
const laborApplyList = () => import("@/views/Labor_insurance/components/labor-apply-list.vue");//劳保物资申领列表


//TODO：安全投入管理
const safeinvesttype = () => import("@/views/Safety_input/safe-invest-type.vue");//安全投入类型
const safetyinputlist= () => import("@/views/Safety_input/Safety-input-list.vue");//安全生产费来源记录
const safetyoutlist = () => import("@/views/Safety_input/Safety-out-list.vue");//安全生产费支出记录
const safetyProclist = () => import("@/views/Safety_input/Safety-proc-list.vue");//安全费用提取台账

//TODO：应急物资出入库记录
const indexRecord = () => import("@/views/emergency_management/components/safe-Emergency-Supplies/index.vue");//物资出库/入库/归还记录
const InsetStorageRecord = () => import("@/views/emergency_management/components/safe-Emergency-Supplies/InsetStorage-record.vue");//应急物资入库记录
const OutStorageRecord = () => import("@/views/emergency_management/components/safe-Emergency-Supplies/OutStorage-record.vue");//应急物资出库记录

//TODO：安全培训
const safeTrainingBank = () => import("@/views/Safety_training/safe-Training-Bank.vue");//题库管理
const safeTrainingLearnClassification = () => import("@/views/Safety_training/safe-Training-Learn-Classification.vue");//学习分类
const safeTrainingCurriculumCentre = () => import("@/views/Safety_training/safe-Training-Curriculum-Centre.vue");//课程内容
const safeTrainingResources = () => import("@/views/Safety_training/safe-Training-Resources.vue");//资源管理
const safeTrainingStudyRecord = () => import("@/views/Safety_training/safe-Training-StudyRecord.vue");//学习记录
const safeTakeNotes = () => import("@/views/Safety_training/safe-Take-Notes.vue");//考试记录
const safeTrainingTestPaperManagement = () => import("@/views/Safety_training/safe-Training-TestPape-rManagement.vue");//试卷管理
const safeTrainingRecords = () => import("@/views/Safety_training/safe-Training-Records.vue");//培训记录
const safeTrainingStatistics = () => import("@/views/Safety_training/safe-Training-Statistics.vue");//培训统计
const safeTrainingMyCourse = () => import("@/views/Safety_training/safe-Training-myCourse.vue");//我的课程
const safeTrainingProgrammes = () => import("@/views/Safety_training/safe-Training-programmes.vue");//培训计划

//TODO：证照管理
const safepermits = () => import("@/views/permits/permits.vue");//证件信息
const safewarning = () => import("@/views/permits/warning.vue");//证照预警

//TODO： 台账管理
const safeAccountsRecords = () => import("@/views/AccountsSys/accounts-Records.vue");//台账信息

//TODO：公文管理
const safeOfficialLists = () => import("@/views/Document_Management/safe-Official-Lists.vue");//公文列表

//TODO：承诺书管理
const safePromiseLists = () => import("@/views/Document_Management/safe-Promise-Lists.vue");//承诺列表
const safeOfficialArchive = () => import("@/views/Document_Management/safe-Official-Archive.vue");//承诺书存档

//TODO：信息管理
const mailbox = () => import("@/views/Mailbox/index.vue");//信息管理

//TODO：会议管理
const safeTodoMeetingList = () => import("@/views/Meeting/safe-todoMeetingList.vue");//待办会议
const safeMeetingList = () => import("@/views/Meeting/safe-meetingList.vue");//会议列表

//TODO：租户管理
const safeTenantsList = () => import("@/views/Management_of_tenants/List-of-tenants.vue");//租户列表
const safeTenantsSet = () => import("@/views/Management_of_tenants/Set-up-for-tenants.vue");//租户套餐设置

//TODO：审批流程设计管理
const formsPanel = () => import("@/views/admin/FormsPanel.vue");//表单列表
const design = () => import("@/views/admin/FormProcessDesign.vue");//表单流程设计


//TODO:工作流程制作
const example = () => import("@/views/sysset/safe-example.vue");//工作流程制作



//TODO：事务管理
const safeapprovecheck = () => import("@/views/myapprove/safe-approve-check.vue");//检查记录审核
const safeapprovedangersAcceptance = () => import("@/views/myapprove/safe-approve-dangers-Acceptance.vue");//隐患指派审核
const safeapprovedangers = () => import("@/views/myapprove/safe-approve-dangers.vue");//隐患验收审核
const safeapproverisk = () => import("@/views/myapprove/safe-approve-risk.vue");//风险审核
const safeapproveConstruction = () => import("@/views/myapprove/safe-approve-Construction.vue");//危险作业计划审核
const safeapproveConstructionop = () => import("@/views/myapprove/safe-approve-Construction-op.vue");//特种作业计划审核
const safeApproveSupplies = () => import("@/views/myapprove/safe-approve-Supplies.vue");//应急物资申领审核
const safeApproveLabor = () => import("@/views/myapprove/safe-approve-labor.vue");//劳保物资申领审核


//TODO:日志管理
const safeLogList = () => import("@/views/log/safe-log-list.vue");//日志列表
const safeLogApprove = () => import("@/views/log/safe-log-approve.vue");//安全员日志审核

//评估报告管理
const safeReportSetting = () => import("@/views/Report/safe-report-setting.vue");//报告信息设置


//TODO:待办事项
const safeAgent = () => import("@/views/Agent/Agent.vue");//代办事项

//TODO:边坡监测
const safedisplacement = () => import("@/views/SlopeMonitoring/Aabsolute-displacement.vue");//绝对位移
const safeenvfactors = () => import("@/views/SlopeMonitoring/Environmental-factors.vue");//环境因素
const safephysicalfield = () => import("@/views/SlopeMonitoring/Physical-field.vue");//物理场
const safeRelativeDisplacement = () => import("@/views/SlopeMonitoring/Relative-displacement.vue");// 相对位移
const safeThresholdConfiguration = () => import("@/views/SlopeMonitoring/Threshold-configuration.vue");// 形变监测阀值配置
const safeVideoplayback = () => import("@/views/SlopeMonitoring/Video-playback.vue");// 录像回放
const safeEnvmonitoring = () => import("@/views/SlopeMonitoring/Environmental-monitoring.vue");// 环境监测
const safeEquipmentmonitoring = () => import("@/views/SlopeMonitoring/Equipment-monitoring.vue");// 工况设备监测



const viewport = {
       content: "width=device-width, initial-scale=1.0, user-scalable=no"
     }


export default [
       
       {path:'/iframe',name:'iframe',component:iframe,meta:{title:'安全社区',keepAlive: true,hasPermission:false,}},//安全社区

       //系统设置
       {path:'/saferole',name:'saferole',component:saferole,meta:{title:'角色管理'}},//角色管理（新）
       {path:'/safepermission',name:'safepermission',component:safepermission,meta:{title:'权限管理'}},//权限管理
       {path:'/safeemployeerole',name:'safeemployeerole',component:safeemployeerole,meta:{title:'人员角色'}},//员工角色
       {path:'/safedictionary',name:'safedictionary',component:safedictionary,meta:{title:'字典管理'}},//字典管理
       {path:'/approvalProcess',name:'approvalProcess',component:approvalProcess,meta:{title:'审批流程'}},//审批流程

       //企业基础信息
       {path:'/archives',name:'archives',component:archives,meta:{title:'企业档案'}},//企业档案
       {path:'/causingDisaster',name:'causingDisaster',component:causingDisaster,meta:{title:'企业技术资料'}},//企业技术资料

       {path:'/formsPanel',name:'formsPanel',component:formsPanel,meta:{title:'表单列表', viewport: viewport,hasPermission:false}},//表单列表
       {path:'/admin/design',name:'design',component:design,meta:{title:'审核流程设置', viewport: viewport,hasPermission:false}},//表单流程设计
       {path:'/example',name:'example',component:example,meta:{title:'工作流程设计',hasPermission:false}},//TODO：工作流程制作

       //组织架构
       {path:'/safeemployee',name:'safeemployee',component:safeemployee,meta:{title:'人员管理'}},//人员管理(新)
       {path:'/safeemployeeinfo',name:'safeemployeeinfo',component:safeemployeeinfo,meta:{title:'员工信息',keepAlive: true,hasPermission:false,}},//员工信息(新)
       {path:'/safeemployeeinfoCustom',name:'safeemployeeinfoCustom',component:safeemployeeinfoCustom,meta:{title:'员工信息',keepAlive: true,hasPermission:false,}},//员工信息-普通员工页面
      
       {path:'/safeemployeeonduty',name:'safeemployeeonduty',component:safeemployeeonduty,meta:{title:'排班管理',keepAlive: false}},//排班管理
       {path:'/safeemployeeclock',name:'safeemployeeclock',component:safeemployeeclock,meta:{title:'人员打卡',keepAlive: false}},//人员打卡
       {path:'/safePostInfo',name:'safePostInfo',component:safePostInfo,meta:{title:'岗位职责',keepAlive: false}},//岗位职责
       {path:'/safeEmployeeChange',name:'safeEmployeeChange',component:safeEmployeeChange,meta:{title:'员工交接班',keepAlive: false}},//员工交接班
       {path:'/safeEmployeeAppoint',name:'safeEmployeeAppoint',component:safeEmployeeAppoint,meta:{title:'任命文件',keepAlive: false}},//任命文件
       

       

       //TODO:履职清单管理
       {path:'/safefulfillConfig',name:'safefulfillConfig',component:safefulfillConfig,meta:{title:'履职明细',keepAlive: false}},//履职明细


       //TODO:风险管理
       {path:'/saferisktype',name:'saferisktype',component:saferisktype,meta:{title:'风险辨识管控'}},//风险辨识管控
       {path:'/saferisklevel',name:'saferisklevel',component:saferisklevel,meta:{title:'风险等级区间'}},//风险等级区间
       // {path:'/saferiskentry',name:'saferiskentry',component:saferiskentry,meta:{title:'风险识别'}},//风险识别
       {path:'/saferiskidetion',name:'saferiskidetion',component:saferiskidetion,meta:{title:'风险清单'}},//风险清单
       {path:'/safeSummaryapprove',name:'safeSummaryapprove',component:safeSummaryapprove,meta:{title:'风险转隐患审核'}},//风险转隐患审核
       {path:'/saferiskarea',name:'saferiskarea',component:saferiskarea,meta:{title:'风险区域分级'}},//风险区域分级
       {path:'/saferiskSummary',name:'saferiskSummary',component:saferiskSummary,meta:{title:'风险初审'}},//风险初审
       {path:'/safeControlRecordsRisk',name:'safeControlRecordsRisk',component:safeControlRecordsRisk,meta:{title:'管控记录'}},//管控记录
       {path:'/safeStatisticalIndicatorsRisk',name:'safeStatisticalIndicatorsRisk',component:safeStatisticalIndicatorsRisk,meta:{title:'风险指标统计'}},//风险指标统计
       {path:'/safeRiskQuadChart',name:'safeRiskQuadChart',component:safeRiskQuadChart,meta:{title:'风险四色图'}},//风险四色图

       
    
       
       //TODO:进出场设置
       {path:'/safeVenueSetting',name:'safeVenueSetting',component:safeVenueSetting,meta:{title:'场地设置'}},//场地设置
       {path:'/safeVenueRecords',name:'safeVenueRecords',component:safeVenueRecords,meta:{title:'进出场记录'}},//进出场记录

       //TODO:合作方管理
       {path:'/cooperationParty',name:'cooperationParty',component:cooperationParty,meta:{title:'合作方列表'}},//合作方列表
       
       //TODO:安全预警
       {path:'/safeVideoConfig',name:'safeVideoConfig',component:safeVideoConfig,meta:{title:'摄像头配置'}},//摄像头配置
       {path:'/safeVideoList',name:'safeVideoList',component:safeVideoList,meta:{title:'监控列表'}},//监控列表
       {path:'/safeAlglist',name:'safeAlglist',component:safeAlglist,meta:{title:'AI算法列表'}},//Ai算法列表
       {path:'/safeVideoAnalysis',name:'safeVideoAnalysis',component:safeVideoAnalysis,meta:{title:'AI视频分析'}},//AI视频分析
       {path:'/safeAlarmlist',name:'safeAlarmlist',component:safeAlarmlist,meta:{title:'AI报警列表'}},//AI报警列表
      
       //TODO:告警记录
       {path:'/safeBusWarning',name:'safeBusWarning',component:safeBusWarning,meta:{title:'告警记录'}},//告警记录
      
       
       
       //TODO:监控设备管理
       {path:'/monitorRecords',name:'MonitorRecords',component:MonitorRecords,meta:{title:'监控设备列表'}},//监控设备列表


       //TODO:法律法规
       {path:'/safethelawItems',name:'safethelawItems',component:safethelawItems,meta:{title:'法律规范'}},//法律规范
       {path:'/safeCorporateSystem',name:'safeCorporateSystem',component:safeCorporateSystem,meta:{title:'制度流程'}},//制度流程
       {path:'/safeRulesRegulations',name:'safeRulesRegulations',component:safeRulesRegulations,meta:{title:'规章制度'}},//规章制度

       //TODO：安全检查
       {path:'/securityConfig',name:'securityConfig',component:securityConfig,meta:{title:'检查表配置'}},//检查表配置
       {path:'/checkScheduling',name:'checkScheduling',component:checkScheduling,meta:{title:'检查排班'}},//检查排班
       {path:'/securityMission',name:'securityMission',component:securityMission,meta:{title:'安全检查台账'}},//安全检查台账
       {path:'/safeCheckStatistical',name:'safeCheckStatistical',component:safeCheckStatistical,meta:{title:'安全检查统计'}},//安全检查统计
       {path:'/checkCardRecords',name:'checkCardRecords',component:checkCardRecords,meta:{title:'区域签到台账'}},//区域签到台账
       {path:'/checkSummary',name:'checkSummary',component:checkSummary,meta:{title:'安全检查汇总'}},//安全检查汇总

       //TODO：安全作业计划管理
       
       {path:'/checkUnitSettings',name:'checkUnitSettings',component:checkUnitSettings,meta:{title:'作业单位设置'}},//作业单位设置
       {path:'/checkConstructionplay',name:'checkConstructionplay',component:checkConstructionplay,meta:{title:'危险作业计划'}},//危险作业计划
       {path:'/checkConstructionOperationsplay',name:'checkConstructionOperationsplay',component:checkConstructionOperationsplay,meta:{title:'特种作业计划'}},//特种作业计划


       {path:'/checkConfirmTicket',name:'checkConfirmTicket',component:checkConfirmTicket,meta:{title:'安全确认票配置'}},//安全确认票配置
       {path:'/checkConfirmTicketRecords',name:'checkConfirmTicketRecords',component:checkConfirmTicketRecords,meta:{title:'风险告知书'}},//安全确认票历史
       {path:'/checkConfirmHistory',name:'checkConfirmHistory',component:checkConfirmHistory,meta:{title:'确认票发送历史'}},//确认票发送历史


       //TODO：设备管理
       {path:'/device',name:'device',component:device,meta:{title:'设备台账'}},//设备台账

       
       //TODO:隐患管理
       {path:'/dangersMission',name:'dangersMission',component:dangersMission,meta:{title:'安全建议/隐患台账'}},//安全建议/隐患台账
       {path:'/safeDangersStatistical',name:'safeDangersStatistical',component:safeDangersStatistical,meta:{title:'隐患治理统计'}},//隐患治理统计
       {path:'/safeSecurityAlert',name:'safeSecurityAlert',component:safeSecurityAlert,meta:{title:'安全预警'}},//安全预警
       {path:'/dangersReport',name:'dangersReport',component:dangersMission,meta:{title:'内部隐患报告'}},//内部隐患报告

       //TODO:隐患报告管理
       {path:'/reportReward',name:'reportReward',component:reportReward,meta:{title:'报告奖励机制'}},//报告奖励
       {path:'/reportList',name:'reportList',component:reportList,meta:{title:'隐患报告台账'}},//隐患报告台账
       {path:'/reportApprove',name:'reportApprove',component:reportApprove,meta:{title:'报告审核记录'}},//报告审核记录

        //TODO:三违管理
       {path:'/Illegal',name:'Illegal',component:Illegal,meta:{title:'三违列表'}},//三违列表

       //TODO:应急管理
       {path:'/safeEmergencyPlan',name:'safeEmergencyPlan',component:safeEmergencyPlan,meta:{title:'应急演练计划'}},//应急演练计划

       {path:'/safeEmergencySupplies',name:'safeEmergencySupplies',component:safeEmergencySupplies,meta:{title:'应急物资台账'}},//应急物资台账
       {path:'/safeEmergencyTem',name:'safeEmergencyTem',component:safeEmergencyTem,meta:{title:'应急小组'}},//应急小组
       {path:'/safeEmergencyProcess',name:'safeEmergencyProcess',component:safeEmergencyProcess,meta:{title:'应急流程'}},//应急流程
       {path:'/safeEmergencyExercise',name:'safeEmergencyExercise',component:safeEmergencyExercise,meta:{title:'单人数字演练'}},//单人数字演练
       {path:'/safeEmergencyExercisePeople',name:'safeEmergencyExercisePeople',component:safeEmergencyExercisePeople,meta:{title:'多人数字演练'}},//多人数字演练

       {path:'/safeEmergencyExerciseResources',name:'safeEmergencyExerciseResources',component:safeEmergencyExerciseResources,meta:{title:'应急演练记录'}},//应急演练记录
       {path:'/safeEmergencyStatistics',name:'safeEmergencyStatistics',component:safeEmergencyStatistics,meta:{title:'年度演练统计'}},//年度演练统计
       {path:'/safeEmergencyExerciseMeet',name:'safeEmergencyExerciseMeet',component:safeEmergencyExerciseMeet,meta:{title:'应急预案'}},//应急预案
       {path:'/safeEmergencyExerciseDrill',name:'safeEmergencyExerciseDrill',component:safeEmergencyExerciseDrill,meta:{title:'应急演练'}},//应急演练
       
   
       //TODO:劳保物资管理
       {path:'/laborlist',name:'laborlist',component:laborlist,meta:{title:'劳保物资列表'}},//劳保物资台账
       {path:'/safeLaborApplyList',name:'laborApplyList',component:laborApplyList,meta:{title:'劳保物资申领记录'}},//劳保物资申领记录


       //TODO:安全投入管理
       {path:'/safeinvesttype',name:'safeinvesttype',component:safeinvesttype,meta:{title:'安全投入类型'}},//安全投入类型
       {path:'/safetyinputlist',name:'safetyinputlist',component:safetyinputlist,meta:{title:'安全生产费投入记录'}},//安全生产费投入记录
       {path:'/safetyoutlist',name:'safetyoutlist',component:safetyoutlist,meta:{title:'安全生产费支出记录'}},//安全生产费支出记录
       {path:'/safetyProclist',name:'safetyProclist',component:safetyProclist,meta:{title:'安全费用提取台账'}},//安全费用提取台账
       
       
       {path:'/safeContingencyPlans',name:'safeContingencyPlans',component:safeContingencyPlans,meta:{title:'应急预案'}},//应急预案
       {path:'/safeEmergencyResources',name:'safeEmergencyResources',component:safeEmergencyResources,meta:{title:'应急资源'}},//应急资源
       {path:'/safeEmergencyTopicSetting',name:'safeEmergencyTopicSetting',component:safeEmergencyTopicSetting,meta:{title:'应急预案题目设置'}},//应急预案题目设置

       //TODO：应急物资出入库记录
       {path:'/indexRecord',name:'indexRecord',component:indexRecord,meta:{title:'物资出库/入库/归还记录',hasPermission:false}},//物资出库/入库/归还记录
       {path:'/InsetStorageRecord',name:'InsetStorageRecord',component:InsetStorageRecord,meta:{title:'应急物资入库记录',hasPermission:false}},//应急物资入库记录
       {path:'/OutStorageRecord',name:'OutStorageRecord',component:OutStorageRecord,meta:{title:'应急物资出库记录',hasPermission:false}},//应急物资出库记录


       //TODO：安全培训
       {path:'/safeTrainingBank',name:'safeTrainingBank',component:safeTrainingBank,meta:{title:'题库管理'}},//题库管理
       {path:'/safeTrainingLearnClassification',name:'safeTrainingLearnClassification',component:safeTrainingLearnClassification,meta:{title:'学习分类'}},//学习分类
       {path:'/safeTrainingCurriculumCentre',name:'safeTrainingCurriculumCentre',component:safeTrainingCurriculumCentre,meta:{title:'课程内容'}},//课程内容
       {path:'/safeTrainingResources',name:'safeTrainingResources',component:safeTrainingResources,meta:{title:'资源管理'}},//资源管理
       {path:'/safeTrainingStudyRecord',name:'safeTrainingStudyRecord',component:safeTrainingStudyRecord,meta:{title:'学习记录'}},//学习记录
       {path:'/safeTakeNotes',name:'safeTakeNotes',component:safeTakeNotes,meta:{title:'考试记录'}},//考试记录
       {path:'/safeTrainingTestPaperManagement',name:'safeTrainingTestPaperManagement',component:safeTrainingTestPaperManagement,meta:{title:'试卷管理'}},//试卷管理
       {path:'/safeTrainingRecords',name:'safeTrainingRecords',component:safeTrainingRecords,meta:{title:'培训记录'}},//培训记录
       {path:'/safeTrainingStatistics',name:'safeTrainingStatistics',component:safeTrainingStatistics,meta:{title:'培训统计'}},//培训统计
       {path:'/safeTrainingMyCourse',name:'safeTrainingMyCourse',component:safeTrainingMyCourse,meta:{title:'我的课程'}},//我的课程
       {path:'/safeTrainingProgrammes',name:'safeTrainingProgrammes',component:safeTrainingProgrammes,meta:{title:'培训计划'}},//培训计划

       //TODO：证照管理
       {path:'/permits',name:'safepermits',component:safepermits,meta:{title:'证件信息'}},//证件信息
       {path:'/warning',name:'safewarning',component:safewarning,meta:{title:'证照预警'}},//证照预警

       //台账管理
       {path:'/safeAccountsRecords',name:'safeAccountsRecords',component:safeAccountsRecords,meta:{title:'台账信息'}},//台账信息
       
       //TODO：公文管理
       {path:'/safeOfficialLists',name:'safeOfficialLists',component:safeOfficialLists,meta:{title:'公文列表'}},//公文列表

       //TODO：承诺书管理
       {path:'/safePromiseLists',name:'safePromiseLists',component:safePromiseLists,meta:{title:'承诺书列表'}},//承诺书列表
       {path:'/safeOfficialArchive',name:'safeOfficialArchive',component:safeOfficialArchive,meta:{title:'承诺书存档'}},//承诺书存档


       
       //TODO：信息管理
       {path:'/mailbox',name:'mailbox',component:mailbox,meta:{title:'信息中心',hasPermission:false},},//信息中心

       //TODO：会议管理
       {path:'/safeTodoMeetingList',name:'safeTodoMeetingList',component:safeTodoMeetingList,meta:{title:'待办会议'}},//待办会议
       {path:'/safeMeetingList',name:'safeMeetingList',component:safeMeetingList,meta:{title:'会议列表'}},//会议列表

       //TODO：租户管理
       {path:'/safeTenantsList',name:'safeTenantsList',component:safeTenantsList,meta:{title:'租户列表'}},//租户列表
       {path:'/safeTenantsSet',name:'safeTenantsSet',component:safeTenantsSet,meta:{title:'套餐设置'}},//套餐设置

    
       //TODO: 事务审核
       {path:'/safeapprovecheck',name:'safeapprovecheck',component:safeapprovecheck,meta:{title:'检查记录审核'}},//检查记录审核
       {path:'/safeapprovedangersAcceptance',name:'safeapprovedangersAcceptance',component:safeapprovedangersAcceptance,meta:{title:'建议/隐患指派审核'}},//隐患指派审核
       {path:'/safeapprovedangers',name:'safeapprovedangers',component:safeapprovedangers,meta:{title:'建议/隐患验收审核'}},//隐患验收审核
       {path:'/safeapproverisk',name:'safeapproverisk',component:safeapproverisk,meta:{title:'风险审核'}},//风险审核
       {path:'/safeapproveConstruction',name:'safeapproveConstruction',component:safeapproveConstruction,meta:{title:'危险作业计划审核'}},//危险作业计划审核
       {path:'/safeapproveConstructionop',name:'safeapproveConstructionop',component:safeapproveConstructionop,meta:{title:'特种作业计划审核'}},//特种作业计划审核
       {path:'/safeApproveSupplies',name:'safeApproveSupplies',component:safeApproveSupplies,meta:{title:'应急物资申领审核'}},//应急物资申领审核
       {path:'/safeApproveLabor',name:'safeApproveLabor',component:safeApproveLabor,meta:{title:'劳保物资申领审核'}},//劳保物资申领审核

       
       //TODO： 日志管理
       {path:'/safeLogList',name:'safeapproverisk',component:safeLogList,meta:{title:'安全员日志'}},//安全日志列表
       {path:'/safeLogApprove',name:'safeLogApprove',component:safeLogApprove,meta:{title:'安全员日志审核'}},//安全员日志审核

       //TODO： 评估报告管理
       {path:'/safeReportSetting',name:'safeReportSetting',component:safeReportSetting,meta:{title:'报告信息设置'}},//报告信息设置


       //TODO： 待办事项
       {path:'/safeAgent',name:'safeAgent',component:safeAgent,meta:{title:'待办事项'}},//待办事项


       //TODO： 边坡监测
       {path:'/safedisplacement',name:'safedisplacement',component:safedisplacement,meta:{title:'绝对位移'}},//绝对位移
       {path:'/safeenvfactors',name:'safeenvfactors',component:safeenvfactors,meta:{title:'环境因素'}},//环境因素
       {path:'/safephysicalfield',name:'safephysicalfield',component:safephysicalfield,meta:{title:'物理场'}},//环境因素
       {path:'/safeRelativeDisplacement',name:'safeRelativeDisplacement',component:safeRelativeDisplacement,meta:{title:'相对位移'}},//相对位移
       {path:'/safeThresholdConfiguration',name:'safeThresholdConfiguration',component:safeThresholdConfiguration,meta:{title:'形变监测阀值配置'}},//形变监测阀值配置
       {path:'/safeVideoplayback',name:'safeVideoplayback',component:safeVideoplayback,meta:{title:'录像回放'}},//录像回放
       {path:'/safeEnvmonitoring',name:'safeEnvmonitoring',component:safeEnvmonitoring,meta:{title:'环境监测'}},//环境监测
       {path:'/safeEquipmentmonitoring',name:'safeEquipmentmonitoring',component:safeEquipmentmonitoring,meta:{title:'工况设备监测'}},//工况设备监测

       
]
